import React, { useState, useEffect, useCallback, useRef } from 'react';
import "../style.css";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Calendar from 'react-calendar';
import 'react-calendar/dist/MyCalendar.css';
import annoucement from '../assets/announcement.png'

function Service() {
    const [events, setEvents] = useState([]);
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state
    const [searchKeyword, setSearchKeyword] = useState(""); // Search keyword state
    const [currentPage, setCurrentPage] = useState(1);
    const resultsPerPage = 8; // Limit results to 8 per page
    const navigate = useNavigate();
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const calendarRef = useRef(null);
    const [selectedEvent, setSelectedEvent] = useState([]); // Initialize as an empty array
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const [noEventsMessage, setNoEventsMessage] = useState(''); // State for no events message

    const toggleCalendar = () => {
        setIsCalendarOpen(prevState => !prevState);
    };
  
      useEffect(() => {
          const handleClickOutside = (event) => {
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
              setIsCalendarOpen(false);
            }
          };
      
          // Add event listener when calendar is open
          if (isCalendarOpen) {
            document.addEventListener('mousedown', handleClickOutside);
          } else {
            document.removeEventListener('mousedown', handleClickOutside);
          }
      
          // Clean up event listener on component unmount or re-render
          return () => {
            document.removeEventListener('mousedown', handleClickOutside);
          };
        }, [isCalendarOpen]);
  
      // Styles for the floating button
      const floatingButtonStyle = {
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: '#007bff',
          color: 'white',
          padding: '10px 20px',
          borderRadius: '20px',
          cursor: 'pointer',
          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
      };
      
      // Styles for the calendar container
      const calendarContainerStyle = {
          position: 'fixed',
          bottom: '70px',
          right: '20px',
          backgroundColor: 'white',
          border: '1px solid #ddd',
          borderRadius: '10px',
          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
          zIndex: 1000,
          padding: '10px',
      };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true); // Start loading
                const response = await axios.get('https://geoid-rest.vercel.app/events');
                setEvents(response.data);
                setFilteredEvents(response.data);
            } catch (error) {
                console.error('Error fetching events data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const openEventViewer = useCallback((mediaId) => {
        navigate(`/events/${mediaId}`); // Navigate to the media ID directly
    }, [navigate]);

    // Handle search
    const handleSearch = (e) => {
        const keyword = e.target.value.trim().toLowerCase();
        setSearchKeyword(keyword);

        const filtered = events.filter(item =>
            item.title.toLowerCase().includes(keyword) ||
            item.organizer.toLowerCase().includes(keyword)
        );
        setFilteredEvents(filtered);
    };

    // Handle pagination
    const indexOfLastMedia = currentPage * resultsPerPage;
    const indexOfFirstMedia = indexOfLastMedia - resultsPerPage;
    const currentMediaItems = filteredEvents.slice(indexOfFirstMedia, indexOfLastMedia);
    const totalPages = Math.ceil(filteredEvents.length / resultsPerPage);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDateClick = (date, event) => {
        const eventDate = date.toISOString().split('T')[0]; // Format date to YYYY-MM-DD
        const eventsOnDate = events.filter(event => 
            new Date(event.date).toISOString().split('T')[0] === eventDate
        );

        if (eventsOnDate.length > 0) {
            // Set all events for the selected date
            setSelectedEvent(eventsOnDate);
            setNoEventsMessage(''); // Clear no events message
            setPopupPosition({
                top: event.clientY + 10, // Adjust as needed
                left: event.clientX + 10 // Adjust as needed
            });
        } else {
            // Set no events message
            setSelectedEvent([]); // Clear selected events
            setNoEventsMessage('No events for this date.'); // Set message
        }
    };

    if (loading) {
        return (
            <div className="loading-screen">
                <p>Loading data...</p>
            </div>
        );
    }

    return (
        <div>
            <section className="hero-events">
                <div>
                    <h1>Join GeoID<u>ly</u> events, tailored for you!</h1>
                    <p>Explore all of our scheduled events</p>
                    <div className="search-container">
                        <input
                            type="text"
                            placeholder="Search name, location, category..."
                            className="search-bar-page"
                            value={searchKeyword}
                            onChange={handleSearch}
                        />
                    </div>
                </div>
            </section>
            <div className="model-page">
                <div className="artifacts-grid-model">
                    {currentMediaItems.map((item) => (
                        <div className="artifact-card" key={item._id}>
                            {item.type === "image" ? (
                                <img src={item.imgSrc} alt={item.name} className="artifact-image" />
                            ) : (
                                <video className="artifact-image" src={item.imgSrc} alt={item.name} />
                            )}
                            <div className="event-info">
                                <h3>{item.title.length > 27 ? `${item.title.slice(0, 27)}...` : item.title} ({item.venue})</h3>
                                <p>{new Date(item.date).toLocaleDateString('en-GB')}</p><p>{item.startTime}</p>                            </div>
                            <div>
                                <button className="view-button-event" onClick={() => openEventViewer(item._id)}>
                                    View Events >
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

            </div>

            <div className="pagination-controls">
                    <button onClick={handlePreviousPage} disabled={currentPage === 1}>
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index + 1}
                            onClick={() => handlePageClick(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button onClick={handleNextPage} disabled={currentPage >= totalPages}>
                        Next
                    </button>
                </div>

            {/* Floating Button */}
            <div style={floatingButtonStyle} onClick={() => {
                toggleCalendar();
                setSelectedEvent([]);
            }}>
                <p>Upcoming Event</p>
                <img style={{width: '30px', height: '30px'}} src={annoucement}/>
            </div>

            {/* Calendar Component */}
            {isCalendarOpen && (
                <div style={calendarContainerStyle} ref={calendarRef}>
                    <Calendar
                        tileContent={({ date }) => {
                            const eventDate = date.toISOString().split('T')[0];
                            const eventsOnDate = events.filter(event => 
                                new Date(event.date).toISOString().split('T')[0] === eventDate
                            );

                            return eventsOnDate.length > 0 ? <div className="event-marker" /> : null;
                        }}
                        onClickDay={handleDateClick} // Handle date click
                    />
                    
                    {/* Displaying events for the selected date */}
                    {selectedEvent.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{color: "#333", fontStyle: 'italic'}}>Events:</span>
                            {selectedEvent.map((event, index) => (
                                <div key={index} className="event-detail">
                                    <h4>{event.title}</h4>
                                    <p>{new Date(event.date).toLocaleDateString('en-GB')}</p>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{ color: '#333', fontStyle: 'italic' }}>{noEventsMessage}</div>
                    )}
                </div>
            )}
        </div>
    );
}

export default Service;